export const SetCookie = (cname: string, cvalue: string, exhours: number, useLocalStorage: boolean) => {
    if (useLocalStorage === true) {
        localStorage.setItem(cname, JSON.stringify(cvalue));
    }
    else {
        const d = new Date();
        d.setTime(d.getTime() + (exhours * 60 * 60 * 1000));
        let expires = "expires="+d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
};

export const GetCookie = (cname: string, useLocalStorage: boolean) => {
    if (useLocalStorage === true) {
        let value = localStorage.getItem(cname);
        if (value === undefined || value === "undefined" || value === null || value === "") {
            return null;
        }
        value = JSON.parse(value);
        return value;
    }
    else {
        let name = cname + "=";
        let ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
};

export const DeleteCookie = (name: string, useLocalStorage: boolean) => {
    if (useLocalStorage === true) {
        if (localStorage.getItem(name) !== null) {
            localStorage.removeItem(name);
            return true;
        }
        else {
            return false;
        }
    }
    else {
        if (GetCookie(name, false)) {
            document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
            return true;
        }
        return false;
    }
};

export const ClearCookies = (useLocalStorage: boolean) => {
    console.log('Cleaning cookies...')
    if (useLocalStorage === true) {
        localStorage.clear()
        window.dispatchEvent(new CustomEvent('authStateChange'))
        return true;
    } else {
        return true;
    }
}